<template>
  <div id="app">
    <h1 style="display: none;">{{ $i18n.locale === 'zn'? '成都奕成科技股份有限公司-官网-奕成科技 ECHINT':'Chengdu ECHINT Technology Co., Ltd.'}}</h1>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {}
}
</script>

<style>
/* @import "./assets/css/OPPOSans-R.css"; */
@import "./assets/css/main.css";
</style>



// WEBPACK FOOTER //
// src/App.vue